import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import SearchIcon from '@material-ui/icons/Search'

const styles = theme => ({
  root: {
    height: 41,
    display: 'flex',
    letterSpacing: 1,
    borderRadius: 100,
    position: 'relative',
    alignItems: 'center',
    justfiyContent: 'flex-start',
    border: '1px solid #e0e2e5',
    padding: `0 ${theme.spacing(2)}px`,
  },
  searchIcon: {
    fontSize: 24,
    color: '#A3A5A8',
    marginRight: theme.spacing(0.5),
  },
  placeholder: {
    top: 11,
    left: 45,
    fontSize: 16,
    position: 'absolute',
    pointerEvents: 'none',
    transition: 'all .2s ease',
    color: theme.palette.text.disabled,
  },
})

class SearchField extends React.PureComponent {
  state = {
    value: '',
    focused: false,
  };

  onFocus = (event) => {
    this.setState({
      focused: event.target === document.activeElement,
    })
  };

  onChange = (event) => {
    const { onChange, delay } = this.props
    const { value } = event.target

    this.setState({ value })
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(() => {
      onChange(value)
    }, delay)
  };

  render() {
    const { value, focused } = this.state
    const {
      classes,
      className,
      width,
      hintText,
      onChange,
      ...fieldProps
    } = this.props

    return (
      <div className={classNames(classes.root, className)}>
        <SearchIcon
          color="secondary"
          classes={{ colorSecondary: classes.searchIcon }}
        />
        <TextField
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onFocus}
          value={this.state.value || ''}
          style={{ width }}
          InputProps={{
            disableUnderline: true,
          }}
          {...fieldProps}
        />
        {value.length === 0 && (
          <div
            className={classes.placeholder}
            style={{ transform: focused ? 'translateX(6px)' : 'none' }}>
            <Typography style={{ fontSize: 16 }}>
              {hintText || 'Search'}
            </Typography>
          </div>
        )}
      </div>
    )
  }
}

SearchField.defaultProps = {
  delay: 500,
  width: 200,
  onChange: () => { },
}

SearchField.propTypes = {
  delay: PropTypes.number,
  width: PropTypes.number,
  onChange: PropTypes.func,
  classes: PropTypes.object,
  hintText: PropTypes.string,
  className: PropTypes.string,
}

export default withStyles(styles)(SearchField)



// WEBPACK FOOTER //
// ./src/components/atoms/SearchField.js